import { Link } from 'react-router-dom';
import useInView from '../../../hooks/useInView';

export default function HomeCTA() {
  const { ref, visible } = useInView(0.2);

  return (
    <section className="py-12 md:py-16 bg-blue-50/50 relative overflow-hidden border-t border-gray-100">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-blue/30 to-transparent"></div>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-brand-blue/10 rounded-full blur-[100px]"></div>
      </div>

      <div
        ref={ref}
        className="relative z-10 max-w-site mx-auto px-4 sm:px-6 text-center"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(24px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease',
        }}
      >
        <span className="inline-block text-[11px] font-bold uppercase tracking-widest text-brand-blue mb-4">
          Ready to Start?
        </span>
        <h2 className="font-display font-bold text-2xl md:text-3xl lg:text-4xl text-gray-900 leading-tight mb-4 max-w-2xl mx-auto">
          Let's Grow Your Business Online
        </h2>
        <p className="text-gray-600 text-sm md:text-[15px] leading-relaxed max-w-xl mx-auto mb-7">
          Whether you have a clear brief or are still figuring things out — we're happy to have an honest conversation about what's possible.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="btn-primary text-base px-8 py-4"
          >
            Get In Touch
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="btn-secondary text-base px-8 py-4"
          >
            Learn About Us
          </Link>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-5 md:gap-8">
          {[
            { icon: 'ri-time-line',         text: 'Respond within 1 business day' },
            { icon: 'ri-chat-3-line',        text: 'No sales pressure'             },
            { icon: 'ri-shield-check-line',  text: 'Your info stays private'       },
          ].map(item => (
            <div key={item.text} className="flex items-center gap-2 text-gray-600 text-sm">
              <i className={`${item.icon} text-brand-blue`}></i>
              {item.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
